var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueDatetime',_vm._g(_vm._b({staticClass:"base-datetime",attrs:{"phrases":{ok: 'Næste', cancel: 'Afslut'},"input-class":"base-input","type":"datetime","format":"dd/MM/yyyy HH:mm"}},'VueDatetime',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }